import React from 'react'
import { Link } from 'react-router-dom'

function PostTemplate({imageUrl, title, author, postId, dateFormatted}) {
    return (
        <div className="col-lg-4">
            <div className="card my-3">
                <Link to={`/innlegg/single/${postId}`}>
                    <img 
                    src={imageUrl} 
                    alt={title} 
                    className="img-fluid" 
                    style={{objectFit: "cover", width: "500px", height: "300px"}}
                    />
                </Link>
                <div className="card-body">
                    <h6><Link className="text-dark" to={`/innlegg/single/${postId}`}>{title}</Link></h6>
                    <small className="text-muted">By {author} on {dateFormatted}</small>
                </div>
            </div>
        </div>
    )
}
export default PostTemplate